export default "__VITE_ASSET__9a4df072__"